import React, { useState, useEffect } from "react";
import statistiquesFacebook from "./../../../../services/MarketingService/StatistiquesFacebook";
import publicationService from "./../../../../services/MarketingService/PublicationService";
import { useParams } from "react-router-dom";
import JSZip from "jszip";
import moment from "moment";

function PublicationInstagram({id}) {
  const [data, setData] = useState({});
  const [photos, setPhotos] = useState([]);
  const [images, setImages] = useState([]);

  //statistiques
  const [loading, setLoading] = useState(true);
  const [erreur, setErreur] = useState(null);
  const [success, setSuccess] = useState(null);
  const [reactions, setReactions] = useState(0);
  const [comments, setcomments] = useState(0);
  const [insights, setInsights] = useState(0);
  const [saved, setSaved] = useState(0);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      setLoading(true);
      await Promise.all([
        getReactionsCountForPostInstagram(),
        getCommentsCountForPostInstagram(),
        getSavedCountForPostInstagram(),
        getvuCountForPostInstagram(),
      ]);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setErreur(error.message);
      setLoading(false);
    }
  };

  // Afficher le nombre de reactions for post
  const getReactionsCountForPostInstagram = async () => {
    const response =
      await statistiquesFacebook.getReactionsCountForPostInstagram(id);
    setReactions(response.data.success);
  };

  // Afficher le nombre de comments for post
  const getCommentsCountForPostInstagram = async () => {
    const response =
      await statistiquesFacebook.getCommentsCountForPostInstagram(id);
    setcomments(response.data.success);
  };

  // Afficher le nombre de saved for post
  const getSavedCountForPostInstagram = async () => {
    const response = await statistiquesFacebook.getSavedCountForPostInstagram(
      id
    );
    setSaved(response.data.success);
  };

  // Afficher le nombre de vu for post
  const getvuCountForPostInstagram = async () => {
    const response = await statistiquesFacebook.getvuCountForPostInstagram(id);
    setInsights(response.data.success);
  };

  const fetchData = async () => {
    try {
      const response = await publicationService.getPublicationByID(id);
      setData(response.data.success);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  return (
    <>
      {/* Main content */}
      <section className="content">
        {/* Row */}
        <div className="row">
          <div className="col-lg-3 col-6">
            <div
              className="card mb-4 small-box"
              style={{ backgroundColor: "#939393" }}
            >
              <div className="inner" style={{ color: "white" }}>
                {loading ? (
                  <div className="lds-dual-ring"></div>
                ) : (
                  <h3>{reactions}</h3>
                )}
                <p>Reactions</p>
              </div>
              <div className="icon">
                <i className="nav-icon fas fa-thin fa-heart"></i>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-6">
            <div className="card mb-4 small-box bg-secondary">
              <div className="inner" style={{ color: "white" }}>
                {loading ? (
                  <div className="lds-dual-ring"></div>
                ) : (
                  <h3>{comments}</h3>
                )}
                <p>Commentaires</p>
              </div>
              <div className="icon">
                <i className="nav-icon fas fas fa-newspaper"></i>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-6">
            <div
              className="card mb-4 small-box "
              style={{ backgroundColor: "#384454" }}
            >
              <div className="inner" style={{ color: "white" }}>
                {loading ? (
                  <div class="lds-dual-ring"></div>
                ) : (
                  <h3>{insights}</h3>
                )}
                <p>Vu</p>
              </div>
              <div className="icon">
                <i className="nav-icon fas fa-address-card"></i>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-6">
            <div
              className="card mb-4 small-box"
              style={{ backgroundColor: "#317AC1" }}
            >
              <div className="inner" style={{ color: "white" }}>
                {loading ? <div class="lds-dual-ring"></div> : <h3>{saved}</h3>}
                <p>Saved</p>
              </div>
              <div className="icon">
                <i className="nav-icon fas fa-regular fa-gift"></i>
              </div>
            </div>
          </div>
        </div>
        {/*end of row*/} {/*row*/}
        <div className="row row-cols-2"></div>
        {/*end of row*/}
      </section>
    </>
  );
}

export default PublicationInstagram;
